var MotionGlobalConfig = {
  skipAnimations: false,
  useManualTiming: false
};
export { MotionGlobalConfig };